const PBF_SELECTOR = '[data-f-id="pbf"]';
const PBF_FALLBACK_RE = /<([a-zA-Z]+)[^>]*\bdata-f-id="pbf"[^>]*>[\s\S]*?<\/\1>/g;

export const extractCellText = (html: string): string => {
  if (typeof document !== "undefined") {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    for (const el of Array.from(tmp.querySelectorAll(PBF_SELECTOR))) {
      el.remove();
    }
    return (tmp.textContent || "").trim();
  }
  return html
    .replace(PBF_FALLBACK_RE, "")
    .replace(/<[^>]*>/g, "")
    .trim();
};
